module.exports = __webpack_public_path__ + "static/media/darkblue-arrow-right.53789028.svg";